import { safeGetItem, safeRemoveItem, safeSetItem } from "@/utils/storage";

// The active team id from the last profile read, so a cold page load can
// start team and list reads alongside the profile read instead of after it.
// It is only a head start: the profile read still decides the team, and a
// mismatch is replaced as soon as it arrives.
const KEY = "lastActiveTeam";

export function rememberActiveTeam(email: string, teamId: string): void {
  if (!email || !teamId) {
    return;
  }
  safeSetItem(KEY, JSON.stringify({ email: email.toLowerCase(), teamId }));
}

export function readRememberedActiveTeam(email: string): string {
  if (!email) {
    return "";
  }
  try {
    const saved = JSON.parse(safeGetItem(KEY) || "null");
    return saved &&
      saved.email === email.toLowerCase() &&
      typeof saved.teamId === "string"
      ? saved.teamId
      : "";
  } catch {
    return "";
  }
}

export function forgetActiveTeam(): void {
  safeRemoveItem(KEY);
}
